import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QuestionCreationTaskList,
  QuestionCreationTaskStatusFilter,
} from '@exam-management/question-creation-task-list';
import { useNavigate } from '@exam-management/router';
import { AddRoundedIcon, Button, Flex, PaperSection } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function QuestionCreationPage() {
  const navigate = useNavigate();

  const handleCreateTaskClick = () => {
    navigate('/task-management/question-creation/create');
  };

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW}>
      <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
        <PaperSection
          title='Question Creation'
          endAdornment={
            <WithPermission
              requiredPermission={[
                APP_PERMISSIONS.TASK.QUESTION_CREATION.CREATE,
                APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
                APP_PERMISSIONS.SETTING.USER.VIEW,
              ]}
            >
              <Button
                variant='contained'
                startIcon={<AddRoundedIcon />}
                onClick={handleCreateTaskClick}
              >
                Create Task
              </Button>
            </WithPermission>
          }
          sx={{ flexGrow: 1 }}
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              border: `1px solid ${theme.palette.grey[300]}`,
              borderRadius: theme.shape.rounded(2),
              m: theme.spacing(6),
              height: '100%',
              overflow: 'hidden',
            })}
          >
            <QuestionCreationTaskStatusFilter />
            <QuestionCreationTaskList />
          </Flex>
        </PaperSection>
      </Flex>
    </PermissionGuard>
  );
}
